
import { combineLatest as observableCombineLatest, Observable, Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { Component, Input, ViewEncapsulation } from '@angular/core';
import { Store } from '@ngrx/store';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { AppState } from '../../../interfaces/app-state.interface';

@Component({
    selector: 'tr-suitability-question-multiple-answers' ,
    templateUrl: './tr-suitability-question-multiple-answers.component.html',
    styleUrls: ['./tr-suitability-question-multiple-answers.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class TrSuitabilityQuestionMultipleAnswersComponent {

    @Input() public set code(value: string) {
        this._code = value;
        this.init(value);
    }
    @Input() public formCtrlName: FormGroup = new FormGroup({});

    public form: FormGroup;
    public subQuestionsAnswersForm: FormGroup;
    public question: any;
    public answers = [];
    private payload: any;
    // tslint:disable-next-line:variable-name
    private _code: string;
    private suitabillity$: Observable<any>;
    private suitabiitySubscription: Subscription;

    constructor(
        private store: Store<AppState>,
        private formBuilder: FormBuilder,
    ) {
        this.suitabillity$ = this.store.select((s) => s.suitability);
        this.form = this.formBuilder.group({});
        this.subQuestionsAnswersForm = this.formBuilder.group({});

        // ??
        this.subQuestionsAnswersForm.valueChanges
            .subscribe((payload) => {

                const value = [];
                Object.keys(payload)
                    .forEach((key) => {
                        value.push({
                            questionID: this.question.id,
                            subQuestionID: +key,
                            answerID: payload[key] ? payload[key] : 0,
                        });
                    });

                this.formCtrlName.patchValue(value);

            });

        this.form.valueChanges.pipe(
            filter(() => {
                return this.formCtrlName.value.length && typeof(this.formCtrlName.value) === 'object';
            }))
            .subscribe((payload) => {

                const value = [];
                this.payload = payload;

                Object .keys(payload)
                    .forEach((key) => {
                        const num = +key;

                        value.push({
                            questionID: this.question.id,
                            subQuestionID: num,
                            answerID: (payload[key]) ? this.subQuestionsAnswersForm.value[key] : 0,
                        });

                        if (this.subQuestionsAnswersForm.controls[num]) {
                            if (payload[key] ) {
                                this.subQuestionsAnswersForm.controls[num].setValidators(Validators.required);
                                this.subQuestionsAnswersForm.controls[num].updateValueAndValidity();
                            } else {
                                this.subQuestionsAnswersForm.controls[num].setValidators(null);
                                this.subQuestionsAnswersForm.controls[num].updateValueAndValidity();
                            }
                        }
                    });

                this.formCtrlName.patchValue(value);

            });

    }

    /**
     * Função que verifica e retorna se os campos estão: marcados e com valor de resposta atribuidos
     */
    public formHasError() {
        const formControls = this.form.controls;
        const subQuestionsForm = this.subQuestionsAnswersForm.controls;
        let hasError: boolean = false;
        let counter = 0;
        const payload: any[] = Array.isArray(this.payload) ? this.payload : Object.values(this.payload);
        payload.forEach((item, index) => {
            if (formControls[index] && formControls[index].value && subQuestionsForm[index].value === 0) {
                this.subQuestionsAnswersForm.controls[index].setErrors({required: true});
                this.subQuestionsAnswersForm.controls[index].markAsTouched();
                this.subQuestionsAnswersForm.updateValueAndValidity();
                hasError = true;
            }
            counter++;
        });
        return hasError;
    }

    private init(code: string) {

        if (!code) return;

        if (this.suitabiitySubscription) {
            this.suitabiitySubscription.unsubscribe();
        }

        this.suitabiitySubscription = observableCombineLatest(
            this.store.select((store) => store.suitability.questions),
            this.store.select((store) => store.suitability.answers),
            this.store.select((store) => store.suitability.usersAnswers),
        )
        .subscribe(([questions, answers, usersAnswers]) => {

            this.question   = questions.find((question) => question.code === this._code) || {};
            this.answers    = answers;

            if (this.question && this.question.subQuestion) {

                this.question.subQuestion
                    .map((subQuestion) => {

                        const relatedAnswer = usersAnswers
                            .filter((answer) => answer.questionID === this.question.id)
                            .find((answer) => answer.subQuestionID === subQuestion.subQuestionID);

                        // Detecta se alternativa já está no form
                        const actualControl = this.form.get(subQuestion.subQuestionID.toString());

                        if (actualControl) {
                            this.form
                                .get(subQuestion.subQuestionID.toString())
                                .patchValue(actualControl.value);
                        } else {

                            this.form.addControl(
                                subQuestion.subQuestionID.toString(),
                                new FormControl(relatedAnswer ? true : false),
                            );
                        }

                        const subQuestionAnswerControl = new FormControl(
                            relatedAnswer ? relatedAnswer.answerID : 0,
                        );

                        if (!this.subQuestionsAnswersForm.get(subQuestion.subQuestionID.toString())) {
                            this.subQuestionsAnswersForm.addControl(
                                subQuestion.subQuestionID.toString(),
                                subQuestionAnswerControl,
                            );
                        } else {

                            this.subQuestionsAnswersForm
                            .get(subQuestion.subQuestionID.toString())
                            .patchValue(subQuestionAnswerControl.value);
                        }

                    });
            }

            this.form.updateValueAndValidity();
            this.subQuestionsAnswersForm.updateValueAndValidity();
        });
    }

}
